import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { useDispatch } from 'react-redux';
import WidgetModel from '@mm/state/model/WidgetModel';
import { uploadFile } from '@mm/state/actions/uploadActions';
import * as Widgets from '@mm/constants/widgets';
import widgetCRUDActions from '@mm/state/actions/WidgetCRUDActions';
import {
  getFormatFromType,
  useCommonWidgetHandlers,
} from './use-common-widget-handlers';

export const useAttachmentWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();
  const dispatch: Dispatch<StoreState> = useDispatch();

  const addFileToWidget = async (widget: WidgetModel, file: File) => {
    if (file) {
      const id = await dispatch(
        uploadFile({
          content: file,
          extension: getFormatFromType(file.type),
        }),
      );

      return dispatch(
        widgetCRUDActions.update({
          ...widget,
          config: {
            ...widget.config,
            title: file.name,
            assetId: id,
          },
        }),
      );
    }
  };

  const addNew = (dialogueId: number, sortOrder: number) => {
    const newWidget = {
      pageId: dialogueId,
      type: Widgets.ATTACHMENT,
      label: 'Untitled attachment',
      sortOrder,
      config: {
        assetId: null,
        title: '',
        description: '',
      },
    };

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    addFileToWidget,
    delete: commonWidgetHandlers.delete,
    addNew,
  };
};
